const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

//const Backofficebff         : string = "/api";
export const RuleServiceQuery: any = {
    DeleteRule: Backofficebff + '/v1/rule/rule/delete',
};
